export const environment = {
  production: true,
  local: false,

  facebookPixel: '634491456648324',
  gtm: 'GTM-5BHQWB',
  gtm_vedia: 'GTM-W3FRV73',

  platform: 'https://www.rawshorts.com',
  
  logout: 'https://accounts.rawshorts.com/logout?service=',

  bundleData: './assets/testdata.json',
  
  fullMenu: false,

  isDevelopment: false,

  getBundleData: 'https://www.rawshorts.com/api/v1/vedia/projects/script/data',
  getImages: 'https://www.rawshorts.com/api/v1/vedia/projects/script/images',
  getImage: 'https://www.rawshorts.com/api/v1/vedia/projects/script/image/url',
  explainerTemplatePath: 'https://www.rawshorts.com/rawshorts/content/vedia/themes/themes.json',
  allProfilesPath: 'https://www.rawshorts.com/engine/api/v1/project/profile/type/',
  storyblocksSearchPath: 'https://www.rawshorts.com/engine/api/v1/asset/storyblocks/{TERM}?page={PAGE}&type=footage&filter=most_recent&count={COUNT}',
  unsplashSearchPath: 'https://www.rawshorts.com/api/v1/services/unsplash/search/{TERM}',
  wikimediaSearchPath: 'https://www.rawshorts.com/api/v1/services/wikimedia/search/{TERM}',
  flickrSearchPath: 'https://www.rawshorts.com/api/v1/services/flickr/search/{TERM}',
  blurEndpoint: 'https://www.rawshorts.com/api/v1/services/images/effects/import?url=',

  bundleDataEndpoint: 'https://www.rawshorts.com/api/v1/vedia/projects/script/data/',
  bundleToProjectEndpoint: 'https://www.rawshorts.com/api/v1/vedia/projects/script',
  pollEndpoint: 'https://www.rawshorts.com/api/v1/projects/list/all',
  pingEndpoint: 'https://www.rawshorts.com/api/v1/projects/ping',
  builder: 'https://www.rawshorts.com/videomaker/',
  signin: 'https://www.rawshorts.com/users/sign_in',
  summary: 'https://www.rawshorts.com/vedia/api/v1/sumy/summary?url_encoded=',
  textNormalize: 'https://www.rawshorts.com/vedia/api/v1/sumy/normalize',
  savedBundleEndpoint: 'https://www.rawshorts.com/api/v1/projects/builder/script/outline/',
  getSubmittedText: 'https://www.rawshorts.com/api/v1/services/queue/get/',
  synonymsApi: 'https://www.rawshorts.com/vedia/api/v1/datamuse/search?query=ml={TERM}&max={COUNT}&v={LANGUANGE}',
  errorEndpoint: 'https://www.rawshorts.com/api/v1/vedia/projects/script/error/',
  azureSearchPath: 'https://www.rawshorts.com/api/v1/services/azure/images/search',
  icons8MessageRequest: 'https://www.rawshorts.com/api/v1/services/icons8/queue',
  vwo: '270024',
  skin: '/rawshorts/content/vedia/skins/default',
  icons8Search: 'https://www.rawshorts.com/engine/api/v1/asset/icons8/',
  imageList: 'https://www.rawshorts.com/api/v1/image/list',
  imageUpload: 'https://www.rawshorts.com/api/v1/image/upload',
  fonts:  'https://www.rawshorts.com/rawshorts/content/builder/API/fonts.json',
  voices: 'https://www.rawshorts.com/rawshorts/content/builder/API/voices.json',
  sounds: 'https://www.rawshorts.com/api/v1/legacy/assets/sounds',
  urlToListicleBundle: 'https://www.rawshorts.com/engine/api/v1/article/listicle/databundle',
  apiCalendarData: 'https://www.rawshorts.com/api/v1/services/internal/calendar',
  apiCreateProject: 'https://www.rawshorts.com/api/v1/projects/create_from_calendar/',
  apiTextToVideoQueue: 'https://www.rawshorts.com/api/v1/services/queue/set',



  rabbitmq: {
    user: 'client_001',
    password: 'CDXNa_glTTMOMlBBtRVyh8D3vLix-KOc',
    url: 'wss://ws.rawshorts.com/ws',
    broker: 'RS.MQ.Broker.Tmp.Projects.Vedia.TextToVideo',
    broker_project: 'RS.MQ.Broker.Tmp.Projects.Vedia.TextToVideo.Project',
    broker_icons8: 'RS.MQ.Broker.Tmp.Projects.Vedia.Icons8.Download',
    broker_images: 'RS.MQ.Broker.Tmp.Projects.Vedia.ArticleToVideo.Images',
    broker_image:  'RS.MQ.Broker.Tmp.Projects.Vedia.ImageProcessor.Image',
    debug: true
  },


hmr: false,

settings: {
        apiSettingsUrl: '/api/v1/vedia/services/rawshorts/settings',
        apiMembersUrl: '/api/v1/vedia/services/rawshorts/members/list',
        apiUserAcceptedUrl: '/api/v1/vedia/services/rawshorts/settings/members/list',
        apiMembersAddUrl: '/api/v1/vedia/services/rawshorts/members/invitation/add',
        apiMembersSentInvitationUrl: '/api/v1/vedia/services/rawshorts/members/invitation/sent',
        apiMembersRevokedInvitationUrl: '/api/v1/vedia/services/rawshorts/members/revoked/invitation',
        apiMembersRevokedUrl: '/api/v1/vedia/services/rawshorts/members/revoked',
        apiTemplatesCreate: '/api/v1/vedia/services/rawshorts/settings/emails/create',
        apiTemplatesRemove: '/api/v1/vedia/services/rawshorts/settings/emails/remove/',
        apiMessagesCreate: '/api/v1/vedia/services/rawshorts/settings/personal_message/create',
        apiMessagesRemove: '/api/v1/vedia/services/rawshorts/settings/personal_message/remove/',
        apiUpdateContact: '/api/v1/vedia/services/rawshorts/settings/update/contact',
        apiUpdateAccount: '/api/v1/vedia/services/rawshorts/settings/update/account',
        apiUpdateSocial: '/api/v1/vedia/services/rawshorts/settings/social_media/update',
        apiUpdateDefaults: '/api/v1/vedia/services/rawshorts/settings/defaults/update',
        apiUploadAvatar: '/api/v1/vedia/services/rawshorts/settings/update/avatar',
        apiCustomScriptsDefaults: '/api/v1/vedia/services/rawshorts/settings/custom_scripts/update',
        apiWhoAmI: '/api/v1/vedia/services/rawshorts/settings/whoami',
        apiPixel: '/api/v1/vedia/services/rawshorts/settings/pixel',
        apiUpdateTag: '/api/v1/vedia/services/rawshorts/settings/snippet_html_id/update',
        apiUpdateStatus: '/api/v1/vedia/services/rawshorts/settings/update_snippet_status/update',
        apiValidateUrl: '/api/v1/vedia/services/rawshorts/settings/snippet_status/validate',
        apiAddProperty: '/api/v1/vedia/services/rawshorts/settings/properties/create',
        apiDeleteProperty: '/api/v1/vedia/services/rawshorts/settings/properties/remove',
        slidesDefaultsList: '/rawshorts/content/vedia/API/slides.json',
        slideUpdate: '/api/v1/vedia/services/rawshorts/settings/update/default/',
        apiLogoUpdate: '/api/v1/vedia/services/rawshorts/settings/update/theme/logo',
        apiListTokens: '/api/v1/vedia/services/rawshorts/settings/plugin/tokens',
        apiAddToken: '/api/v1/vedia/services/rawshorts/settings/plugin/token/new',
        apiRemoveToken: '/api/v1/vedia/services/rawshorts/settings/plugin/token/delete',
        apiImageList: '/api/v1/image/list',
        apiImageUpload: '/api/v1/image/upload',
        apiImageDelete: '/api/v1/image/delete/',
        apiUpdateTagHTMLType: '/api/v1/vedia/services/rawshorts/settings/snippet_html_embed_type/update',
        apiUpdateTagHTMLCOA: '/api/v1/vedia/services/rawshorts/settings/snippet_html_coa/update',
        apiSheetList: '/api/v1/vedia/services/rawshorts/settings/ads/spreadsheet/list',
        apiSheetCreate: '/api/v1/vedia/services/rawshorts/settings/ads/spreadsheet/create',
        apiSheetDelete: '/api/v1/vedia/services/rawshorts/settings/ads/spreadsheet/delete/',
        apiSourceList: '/api/v1/vedia/services/rawshorts/settings/ads/sources/list',
        apiSourceCreate: '/api/v1/vedia/services/rawshorts/settings/ads/sources/create',
        apiSourceDelete: '/api/v1/vedia/services/rawshorts/settings/ads/sources/delete/',
        apiSourcesTypes: '/api/v1/vedia/services/rawshorts/settings/ads/sources/types'
    },
    alert: {
        error: '/api/v1/vedia/services/rawshorts/create/alert',
    },
    messages: {
        apiVideoMessagesURL: 'api/v1/vedia/services/rawshorts/video/message/list',
        apiVediaAccountMembers: 'api/v1/vedia/services/rawshorts/settings/members/list',
        apiVediaMessagesStatusURL: 'api/v1/vedia/services/rawshorts/video/message/video/status/',
        apiVediaMessagesSendURL: 'api/v1/vedia/services/rawshorts/video/message/video/submit/email/',

       apiVediaMessageLandingStatus: 'api/v1/vedia/services/rawshorts/video/message/publish/status/',
       apiVediaMessagePublish: 'api/v1/vedia/services/rawshorts/video/message/publish/',
       apiVediaMessageUnPublish: 'api/v1/vedia/services/rawshorts/video/message/unpublish/',

        /** Status updates */
        apiVediaMessagesStatusImportant: 'api/v1/vedia/services/rawshorts/video/message/important/',
        apiVediaMessagesStatusStarred: 'api/v1/vedia/services/rawshorts/video/message/starred/',
        apiVediaMessagesStatusTrash: 'api/v1/vedia/services/rawshorts/video/message/trash/',
        apiVediaMessagesStatusDelete: 'api/v1/vedia/services/rawshorts/video/message/delete/',
        apiVediaMessagesStatusPurgeAll: 'api/v1/vedia/services/rawshorts/video/message/purge/all',
        apiVediaMessagesPurgeTrash: 'api/v1/vedia/services/rawshorts/video/message/purge/all',
        apiVediaMessagesPermanentDelete: 'api/v1/vedia/services/rawshorts/video/message/delete/'
    },

    vinEdit: {
        processAutomotive: '/engine/api/v1/automotive/project',
        sendEmail: '/engine/api/v1/automotive/project/sendEmail',
        saveEmail: '/engine/api/v1/automotive/project/saveEmail',
        getJobDetails: '/engine/api/v1/automotive/project/snapshot',
        getVinDetails: '/engine/api/v1/automotive/vin',
        getLastMessgeForTopic: '/engine/api/v1/topic/message',
        serverStore: '/engine/api/v1/store',
        processImage: '/engine/api/v1/process/image'
    },

    auth: {
        register: '/api/v1/auth',
        accountConfirm: '/api/v1/vedia/services/rawshorts/auth/confirmation/',
        invitationConfirm: '/api/v1/vedia/services/rawshorts/members/invitation/accepted/',
        passwordConfirm: '/api/v1/vedia/services/rawshorts/auth/password/confirmation/',
        signIn: '/api/v1/auth/sign_in',
        signOut: '/api/v1/auth/sign_out',
        ping: '/api/v1/vedia/services/rawshorts/auth/ping',
        passwordReset: '/api/v1/vedia/services/rawshorts/auth/password/reset',
        forgotPassword: '/api/v1/vedia/services/rawshorts/auth/forgot/password'
    },

airbrake: {
        projectId: '220530',
        licenseKey: '7228cf37a79660f5690f957f57dbe95a'
    },

fileMananger: {
        list: '/api/v1/vedia/services/rawshorts/settings/schemas/list',
        show: '/api/v1/vedia/services/rawshorts/settings/schemas/show/',
        update: '/api/v1/vedia/services/rawshorts/settings/schemas/update/',
        listings: '/api/v1/vedia/services/car_listing/[ORG]/schema/latest'
    },
dasboard: {
        getStats: 'api/v1/vedia/services/rawshorts/settings/stats'
    },
listicle: {
        getListicleVideoStatus: 'api/v1/vedia/services/rawshorts/video/listicle/video/status/',
        publishListicle: 'api/v1/vedia/services/rawshorts/video/listicle/publish/',
        unpublishListicle: 'api/v1/vedia/services/rawshorts/video/listicle/unpublish/',
        deleteListicle: 'api/v1/vedia/services/rawshorts/video/listicle/delete/',
        createListicle: 'api/v1/vedia/services/rawshorts/video/listicle/create',
        showListicle: 'api/v1/vedia/services/rawshorts/video/listicle/show/',
        listListicles: 'api/v1/vedia/services/rawshorts/video/listicle/list',

        duplicate: 'api/v1/vedia/services/rawshorts/video/listicle/child/duplicate/',
        render: 'api/v1/vedia/services/rawshorts/video/listicle/child/render/',
        renderUpdate: 'api/v1/vedia/services/rawshorts/video/listicle/child/render/update/',
        default: 'api/v1/vedia/services/rawshorts/video/listicle/child/default/',
        remove: 'api/v1/vedia/services/rawshorts/video/listicle/child/remove/',
        children: 'api/v1/vedia/services/rawshorts/video/listicle/child/list/',
        childShow: 'api/v1/vedia/services/rawshorts/video/listicle/child/show/:uuid',

        wordpressToListicleData: '/engine/api/v1/article/listicle/wptold',
        noNLP: '/engine/api/v1/article/listicle/nonlp',
        generate: '/engine/api/v1/article/listicle/generate'
},

rewrelic: {
    appName: 'VEDIA.CLIENT.APP',
    licenseKey: '557dacc9a3fe475b1be7302326c9408574ff4a13'
},
hostedvideo: {
    list: 'api/v1/vedia/services/rawshorts/video/hostedvideo/list',
    show: 'api/v1/vedia/services/rawshorts/video/hostedvideo/',
    queueCompleted: 'api/v1/vedia/services/rawshorts/video/hostedvideo/queue/completed/',
    publish: 'api/v1/vedia/services/rawshorts/video/hostedvideo/publish/',
    unpublish: 'api/v1/vedia/services/rawshorts/video/hostedvideo/unpublish/'
},
feeds: {
        apiFeedList: '/api/v1/vedia/services/rawshorts/video/feed/list',
        apiFeedCreate: '/api/v1/vedia/services/rawshorts/video/feed/create',
        apiFeedHistory: '/api/v1/vedia/services/rawshorts/video/forms/exports/list/'
},
ads: {
    apiAdsList: '/api/v1/vedia/services/rawshorts/video/forms/ads/list',
    videoSearch: '/engine/api/v1/core/storyblocks/search',
    updateData: '/engine/api/v1/ads/update',
    getTracks: '/api/v1/legacy/assets/sounds',
    getBlinds: '/engine/api/v1/asset/builder/blinds',
    listVideoForms: '/api/v1/vedia/services/rawshorts/video/forms/ads/all',
    createVideoForms: '/api/v1/vedia/services/rawshorts/video/forms/ads/create',
    deleteVideoForms: '/api/v1/vedia/services/rawshorts/video/forms/ads/deleted/',
    getVideoFormsDraft: '/api/v1/vedia/services/rawshorts/video/forms/ads/draft',
    createVideoFormsDraft: '/api/v1/vedia/services/rawshorts/video/forms/ads/draft/create',
    generateAd: '/engine/api/v1/ads/generate',
    userImages: '/api/v1/image/list',
    overlays: '/uploads/files/vedia/static/overlays/custom-overlays.json',
    spyfuDomain: '/api/v1/services/spyfu/domain/search?domain=',
    spyfuTerm: '/api/v1/services/spyfu/search?term=',
    textPresets: '/rawshorts/content/builder/API/text-presets.json',
    textAnimations: 'uploads/files/vedia/static/text/text-animations.json',
    gettyImages: '/api/v1/vedia/services/getty/images/search/',
    gettyVideos: '/api/v1/vedia/services/getty/videos/search/',
    uploadBucket: '/rawshorts/content/vedia/uploads',
    uploadFile: '/engine/api/v1/core/upload/file',
    uploadJSON: '/engine/api/v1/core/upload/json',
    fonts: '/rawshorts/content/builder/API/fonts.json',
    slideDuration: '/engine/api/v1/core/slide/duration',
    storyblockCache: '/api/v1/vedia/services/rawshorts/cache_storyblock_video',
    panEfectUrl: '/api/v1/video/effects/_EFFECT_TYPE_?url=_IMAGE_',
    textRules: '/uploads/vedia/text_rules.json'
  },
efe: {
    listVideoForms: '/api//v1/vedia/services/rawshorts/video/forms/efe/feed'
    },
  homeReport: {
        apiGenerateReport: '/api/v1/vedia/services/home_listing/report',
        updateProject: '/engine/api/v1/ads/property-report/update'
    },
   images: {
        apiImagesList: '/api/v1/image/list/',
        apiImagesAdd: '/api/v1/image/upload',
        apiImagesDelete: '/api/v1/image/delete/'
    },
   audios:{
       apiAudiosAdd: '/api/v1/audio/upload',
       apiAudiosDelete: '/api/v1/audio/delete/'
   },
   assets: {
       apiAssetsList: '/api/v1/vedia/services/rawshorts/settings/schemas/filelist',
       prepareAssets: '/api/v1/vedia/services/rawshorts/video/forms/prepare/assets/',
       validateAssets: '/api/v1/vedia/services/rawshorts/video/forms/validate/videos/assets/'
   },
   socialCalendar: {
        spreadSheetsList: '/api/v1/vedia/services/rawshorts/video/forms/get/social_calendar',
        quotes: '/api/v1/vedia/services/rawshorts/quotes?q='
    },
    exports: {
        apiExport: 'api/v1/vedia/services/rawshorts/video/forms/queue/export/_UUID_'
     },
   webapp: {
        myAccount: {
            getUser: '/api/v2/rawshorts/user',
            getCredits: '/api/v2/rawshorts/user/credits',
            getExports: '/api/v2/rawshorts/user/exports',
            changePassword: '/api/v2/rawshorts/user/change_password',
            getPurchases: '/api/v2/rawshorts/user/purchases',
            getIntegrations: '/api/v2/rawshorts/user/oauth',
            getIntegrationToggle: '/api/v2/rawshorts/integrations/[SERVICE]/oauth2_urls',
            getProjectPermissions: '/api/v2/rawshorts/projects/:project_id/permissions',
            shareVideo: '/api/v2/rawshorts/integrations/:integration/share',
            shareVideoToDrive: '/api/v2/rawshorts/integrations/google/drive/share',
            getPermissions: '/api/v2/rawshorts/user/permissions',
            inviteTeamMember: '/api/v2/rawshorts/team/invite?email=',
            revokePendingTeamMember: '/api/v2/rawshorts/team/invitation/revoked/',
            removeTeamMember: '/api/v2/rawshorts/team/revoked/',
            resendTeamInvite: '/api/v2/rawshorts/team/invite/:user_id/resend',
        },
        teams: {
              available: '/api/v2/rawshorts/team/available',
              info: '/api/v2/rawshorts/team/info',
              membership: '/api/v2/rawshorts/team/membership',
              members: '/api/v2/rawshorts/team/members',
              owner: '/api/v2/rawshorts/team/owner',
              teamMate: '/api/v2/rawshorts/team/teammate',
        }, 
        myProjects: {
            getList: '/api/v2/rawshorts/projects',
            builderEditor: '/videomaker/:project_id?lite=true&origin=v2',
            legacyShare: '/app/animations/:project_id?origin=v2&type=project',
            submitExport: '/api/v2/rawshorts/projects/:project_id/exports',
            getAllExports: '/api/v2/rawshorts/projects/:project_id/exports',
            getExportInfo: '/api/v2/rawshorts/projects/:project_id/exports/:export_id',
            downloadExport: '/api/v2/rawshorts/projects/:project_id/exports/download/:export_id',
            getDetails: '/api/v2/rawshorts/projects/:project_id/info',
            getCategories: '/api/v2/rawshorts/projects/categories',
            getVersions: '/api/v2/rawshorts/projects/:project_id/versions',
            delete: '/api/v2/rawshorts/projects/:project_id',
            duplicate: '/api/v2/rawshorts/projects/:project_id/duplicate',
            update: '/api/v2/rawshorts/projects/:project_id',
            outlineEditor: '/outline/:project_id?origin=v2',
            shareStatus: '/api/v2/rawshorts/projects/:project_id/share_page/status',
            sharePreview: '/api/v2/rawshorts/projects/:project_id/share_page/preview?origin=v2',
            publish: '/api/v2/rawshorts/projects/:project_id/share_page/publish?origin=v2',
            unpublish: '/api/v2/rawshorts/projects/:project_id/share_page/unpublish',
            outlineOrigin: '/api/v2/rawshorts/projects/:project_id/outline',
            duplicateVersion: '/api/v2/rawshorts/projects/:project_id/duplicate/:version',
            makePrivate: '/api/v2/rawshorts/projects/:project_id/share_page/make_private',
            sharePageStatus: '/api/v2/rawshorts/projects/:project_id/share_page/status',
            getIntegrationShares: '/api/v2/rawshorts/user/exports/shares' ,
        },
        myAssets: {
            apiImagesList: '/api/v2/rawshorts/image',
            apiImagesAdd: '/api/v2/rawshorts/image/upload',
            apiImagesDelete: '/api/v2/rawshorts/image/',
            apiAudioList: '/api/v2/rawshorts/audio',
            apiAudiosAdd: '/api/v2/rawshorts/audio/upload',
            apiAudiosDelete: '/api/v2/rawshorts/audio/',
            apiVideoList: '/api/v2/rawshorts/video',
            apiVideosAdd: '/api/v2/rawshorts/video/upload',
            apiVideosDelete: '/api/v2/rawshorts/video/',
        },
        fileMananger: {
            show: '/api/v2/rawshorts/schemas/',
            update: '/api/v2/rawshorts/schemas/',
        },
        templates: {
            templates: '/api/v2/rawshorts/templates', // language, format, genre, category, offset, limit
            categories: '/api/v2/rawshorts/templates/categories',
            getAll: '/api/v2/rawshorts/templates/all' // lang, genre, category_id, scene_category, format, theme, page
        },
        smc: {
            apiCalendarData: '/api/v1/services/internal/calendar',
            apiCreateProject: '/api/v1/projects/create_from_calendar/',
            apiTextToVideoQueue: '/api/v1/services/queue/set',
            pingEndpoint: '/api/v1/projects/ping',
        },
       stockVideos: {
            curatedVideos: '/rawshorts/content/builder/API/currated_video_list.json',
            videoBackground: '/api/v2/rawshorts/projects/create/videobackground',
            searchVideos: '/api/storyblocks/v1/search/:q/:type/:sort/:page/:count',
        },
        cancellation: {
            summary: '/api/v2/rawshorts/user/summary',
            applyOffer: '/ecommerce/subscription/redeem_cancellation_coupon',
            cancelSubscription: '/ecommerce/subscription/cancel',
        },
    } //End Webapp Variables
}